import { render, staticRenderFns } from "./ModalImport.vue?vue&type=template&id=0a84a786&scoped=true"
import script from "./ModalImport.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalImport.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ModalImport.vue?vue&type=style&index=0&id=0a84a786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a84a786",
  null
  
)

export default component.exports